import { useEffect, useState, useMemo } from 'react';
import { throttle } from 'lodash';

const useScreenWidth = () => {
    const [screenWidth, setScreenWidth] = useState(0);

    const updateScreenWidth = () => {
        if (typeof window !== 'undefined') {
            let windowWidth = window.innerWidth;
            setScreenWidth(windowWidth);
        }
    }

    const throttleUpdateScreenWidth = useMemo(() => throttle(updateScreenWidth, 150), []);

    useEffect(() => {
        window.addEventListener("resize", throttleUpdateScreenWidth);
        updateScreenWidth();
        return () => {
            window.removeEventListener("resize", throttleUpdateScreenWidth);
            throttleUpdateScreenWidth.cancel();
        }
    }, []);

    return screenWidth;
};

export default useScreenWidth;